// Minimal CSV parser supporting quoted fields with embedded commas and
// escaped double-quotes (""). Skips rows whose column count diverges
// from the header — silent column drift is the bug we're avoiding.

export function parseCSV(text) {
  if (!text) return [];
  const lines = text.trim().split('\n');
  if (lines.length < 2) return [];

  const headers = parseLine(lines[0]).map((h) => h.trim());
  const out = [];
  for (let i = 1; i < lines.length; i++) {
    const cells = parseLine(lines[i]).map((c) => c.trim());
    if (cells.length !== headers.length) continue;
    const row = {};
    headers.forEach((h, idx) => { row[h] = cells[idx]; });
    out.push(row);
  }
  return out;
}

function parseLine(line) {
  const cells = [];
  let current = '';
  let inQuotes = false;
  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (inQuotes) {
      if (ch === '"' && line[i + 1] === '"') {
        current += '"';
        i++;
      } else if (ch === '"') {
        inQuotes = false;
      } else {
        current += ch;
      }
    } else {
      if (ch === '"') {
        inQuotes = true;
      } else if (ch === ',') {
        cells.push(current);
        current = '';
      } else {
        current += ch;
      }
    }
  }
  cells.push(current);
  return cells;
}
